import { List, Map } from 'immutable';

export default Map({
  available: Map({
    loading: false,
    error: null,
    data: List(),
  }),
  other: Map({
    loading: false,
    error: null,
    data: List(),
  }),
});
